const rad = (degrees) => degrees * Math.PI / 180;
const deg = (radians) => radians * 180 / Math.PI;
export {
  deg,
  rad
};
//# sourceMappingURL=radians.js.map
